export const DRAFT_MESSAGE_THREAD_ID_PREFIX = 'DRAFT_ID';
